export default __webpack_public_path__ + "static/media/MusicNoteSimple.6ea965ed.svg";